import { render, staticRenderFns } from "./OmsTabs.vue?vue&type=template&id=494b089b&scoped=true"
import script from "./OmsTabs.vue?vue&type=script&lang=js"
export * from "./OmsTabs.vue?vue&type=script&lang=js"
import style0 from "./OmsTabs.vue?vue&type=style&index=0&id=494b089b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b089b",
  null
  
)

export default component.exports